/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import SimplicityImage from "cms/images/index";
import Config from "data/config";

const ImageComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { image, settings } = component || {};
    // const { format, options } = settings || {}
    // const { useCaption, method, dimension, position } = options || {}
    const enableImageDebug = Config.Debug.useDebug;

    return (
        <>
            <SimplicityImage
                image={image}
                settings={settings}
            />
            {enableImageDebug &&
                <>
                    <pre className='in-page-debug'>
                        settings: {JSON.stringify(settings, null, 2)}
                    </pre>
                    <pre className='in-page-debug'>
                        image: {JSON.stringify(image, null, 2)}
                    </pre>
                </>
            }
        </>
    );
};

ImageComponentDisplay.displayName = "ImageComponentDisplay";
export { ImageComponentDisplay };
